import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { GetPersonsWithAccount, PersonOrder } from '../../../Apollo';
import useNotification from 'Hooks/useNotification';
import AccountUsersTable from './AccountUsersTable';
import useTableUserSettings from 'Hooks/useTableUserSettings';

interface Props {
  isMobileP: boolean;
}

function AccountUsersTableContainer(props: Readonly<Props>) {
  const { isMobileP } = props;
  const { accountCode } = useParams<IUriParams>();
  const { onError } = useNotification();

  const {
    selectedIds,
    currentPage,
    rowsPerPage,
    orderBy,
    personFilter,
    handleSearch,
    onChangeRowsPerPage,
    onChangeOrderBy,
    onChangePage,
    handleSelect,
    handleUnselect,
    setSelectedIds
  } = useTableUserSettings(accountCode, PersonOrder.NameAsc);

  const variables = {
    personFilter: {
      accountCode: accountCode === 'all' ? null : accountCode,
      contactDetails: personFilter ?? null
    },
    offset: currentPage * rowsPerPage,
    first: rowsPerPage,
    orderBy
  };

  const { data, loading: fetching, refetch } = useQuery<{
    persons: IPaginatedList<IPersonWithAccount>;
  }>(GetPersonsWithAccount, {
    onError,
    variables
  });

  const handleRefetch = () => {
    refetch();
    setSelectedIds([]);
  };

  let loading = fetching;
  let rows: { node: IPersonWithAccount }[] = [];
  let totalCount = rowsPerPage;

  if (data?.persons) {
    rows = data.persons.edges;
    totalCount = data.persons.totalCount;
  } else {
    loading = true;
  }

  const selectedCount = selectedIds == null ? totalCount : selectedIds.length;

  return (
    <AccountUsersTable
      rows={rows}
      loading={loading}
      selectedCount={selectedCount}
      selectedIds={selectedIds}
      filter={personFilter}
      totalCount={totalCount}
      orderBy={orderBy}
      rowsPerPage={rowsPerPage}
      currentPage={currentPage}
      onSearch={handleSearch}
      onChangeOrderBy={onChangeOrderBy}
      onChangeRowsPerPage={onChangeRowsPerPage}
      onSelect={handleSelect}
      onUnselect={handleUnselect}
      onChangePage={onChangePage}
      onReloadUsers={handleRefetch}
      isMobileP={isMobileP}
    />
  );
}

export default AccountUsersTableContainer;
